import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=ec63ffa6&scoped=true&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&id=ec63ffa6&lang=less&scoped=true&"
import style1 from "./Form.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec63ffa6",
  null
  
)

export default component.exports